import React, { Component } from 'react';
//import './App.css';
import './assets/css/atlas.min.css';
// import './assets/css/cyclops.css'; //TODO: get the latest version and include this again (We can also create a simple npm package to make this process automatic!)

import './assets/js/application.jasset';
import './assets/js/environment.jasset';
import './assets/js/providerRelationships.jasset';
import './assets/js/role.jasset';
import './assets/js/sso.jasset';
import LoadingFS from './components/LoadingFS';
import DevTools from './components/DevTools';



class App extends Component {
    render() {
        return (
            <div className="App">
                <DevTools/>
                <LoadingFS/>
                {this.props.children}
            </div>
        );
    }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/